<template>
    <v-container fluid >
        <div>
            <v-icon left id="icon-within-timerange">mdi-checkbox-blank</v-icon>
            {{ $t('result.resultWithinTimeRange') }} {{$store.state.yearRange.min}}-{{$store.state.yearRange.max}}
        </div>
        <div>
            <v-icon left id="icon-outside-timerange" >mdi-checkbox-blank</v-icon>
            {{ $t('result.resultOutsideTimeRange') }}
            <span v-if="min !== $store.state.yearRange.min && $store.state.yearRange.min != 1800"> {{min}}-{{$store.state.yearRange.min-1}} </span>
            ;
            <span v-if="max !== $store.state.yearRange.max && $store.state.yearRange.max != new Date().getFullYear()"> {{$store.state.yearRange.max + 1}}-{{max}} </span>
        </div>
    </v-container>

</template>

<script>
    import {TIME_RANGE} from '../../data/constants'

    export default {
        name: 'SearchColorLegend',
        data() {
            return {
                min: TIME_RANGE.min,
                max: TIME_RANGE.max,
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../global';

    #icon-outside-timerange {
        color: $app-light-red
    }
    #icon-within-timerange {
        color: $app-dark-red
    }

</style>